import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import eventImage from '../assets/eventimage1.png';



const Event = () => {
    const navigate = useNavigate();
    const [isDateExpanded, setIsDateExpanded] = useState(false);
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });
    const [flippedCard, setFlippedCard] = useState(null);
    const [cardAnimations, setCardAnimations] = useState({});
    const [lightBulbs, setLightBulbs] = useState([
        { id: 1, isOn: false },
        { id: 2, isOn: false },
        { id: 3, isOn: false },
        { id: 4, isOn: false },
        { id: 5, isOn: false },
        { id: 6, isOn: false }
    ]);
    const [curtainOpen, setCurtainOpen] = useState(false);
    const [copyButtonText, setCopyButtonText] = useState('');
    const [isButtonAnimating, setIsButtonAnimating] = useState(false);
    const confettiCanvasRef = useRef(null);
    const animationFrameRef = useRef(null);
    const confettiParticles = useRef([]);
    const informationSectionRef = useRef(null);


    // Etkinlik tarihi - 30 Ağustos 2025, 08:00
    const eventDate = new Date('2025-08-30T08:00:00');

    // Sayfa yüklendiğinde perde otomatik açılsın
    useEffect(() => {
        const timer = setTimeout(() => {
            setCurtainOpen(true);

            // Perde açıldıktan sonra ampulleri yak
            setTimeout(() => {
                const turnOnLights = () => {
                    lightBulbs.forEach((bulb, index) => {
                        setTimeout(() => {
                            setLightBulbs(prev =>
                                prev.map(b =>
                                    b.id === bulb.id ? { ...b, isOn: true } : b
                                )
                            );
                        }, index * 300); // Her ampul 300ms arayla yanar
                    });
                };
                turnOnLights();
            }, 1000); // Perde açılma animasyonu tamamlandıktan sonra
        }, 200); // Sayfa yüklendikten 0.2 saniye sonra perde açılsın

        return () => clearTimeout(timer);
    }, []);

    // Konfeti sınıfı
    class ConfettiParticle {
        constructor(x, y, isPageLoad = false) {
            this.x = x;
            this.y = y;
            this.vx = (Math.random() - 0.5) * (isPageLoad ? 8 : 4);
            this.vy = Math.random() * (isPageLoad ? -15 : -8) - 2;
            this.gravity = 0.3;
            this.friction = 0.99;
            this.size = Math.random() * (isPageLoad ? 8 : 5) + 3;
            this.rotation = Math.random() * 360;
            this.rotationSpeed = (Math.random() - 0.5) * 10;
            this.color = this.getRandomColor();
            this.life = isPageLoad ? 300 : 150;
            this.maxLife = this.life;
        }

        getRandomColor() {
            const colors = [
                '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7',
                '#DDA0DD', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E9'
            ];
            return colors[Math.floor(Math.random() * colors.length)];
        }

        update() {
            this.x += this.vx;
            this.y += this.vy;
            this.vy += this.gravity;
            this.vx *= this.friction;
            this.rotation += this.rotationSpeed;
            this.life--;
        }

        draw(ctx) {
            const alpha = this.life / this.maxLife;
            ctx.save();
            ctx.globalAlpha = alpha;
            ctx.translate(this.x, this.y);
            ctx.rotate(this.rotation * Math.PI / 180);
            ctx.fillStyle = this.color;
            ctx.fillRect(-this.size / 2, -this.size / 2, this.size, this.size);
            ctx.restore();
        }

        isDead() {
            return this.life <= 0 || this.y > window.innerHeight + 100;
        }
    }

    // Konfeti oluşturma fonksiyonu
    const createConfetti = (x, y, count = 30, isPageLoad = false) => {
        for (let i = 0; i < count; i++) {
            confettiParticles.current.push(new ConfettiParticle(x, y, isPageLoad));
        }
    };

    // Konfeti animasyonu
    const animateConfetti = () => {
        const canvas = confettiCanvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        confettiParticles.current = confettiParticles.current.filter(particle => {
            particle.update();
            particle.draw(ctx);
            return !particle.isDead();
        });

        if (confettiParticles.current.length > 0) {
            animationFrameRef.current = requestAnimationFrame(animateConfetti);
        } else {
            // Animasyon bittiğinde frame referansını temizle
            animationFrameRef.current = null;
        }
    };

    // Sayfa yüklendiğinde konfeti yağmuru
    const startPageLoadConfetti = () => {
        const canvas = confettiCanvasRef.current;
        if (!canvas) return;

        // Canvas boyutunu ayarla
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;

        // Birden fazla noktadan konfeti oluştur
        const points = [
            { x: window.innerWidth * 0.2, y: -50 },
            { x: window.innerWidth * 0.4, y: -50 },
            { x: window.innerWidth * 0.6, y: -50 },
            { x: window.innerWidth * 0.8, y: -50 }
        ];

        points.forEach((point, index) => {
            setTimeout(() => {
                createConfetti(point.x, point.y, 50, true);
                if (index === 0) animateConfetti();
            }, index * 200);
        });
    };

    // Buton tıklamasında mini konfeti
    const handleButtonConfetti = (event) => {
        const rect = event.target.getBoundingClientRect();
        const x = rect.left + rect.width / 2;
        const y = rect.top + rect.height / 2;

        createConfetti(x, y, 15, false);
        // Her tıklamada animasyonu başlat
        if (!animationFrameRef.current) {
            animateConfetti();
        }
    };

    // Detaylar butonuna tıklandığında etkinlik bilgileri bölümüne scroll
    const handleDetailsClick = (event) => {
        console.log('Detaylar butonu tıklandı!');
        handleButtonConfetti(event);

        // Her tıklamada scroll yapması için setTimeout kullan
        setTimeout(() => {
            if (informationSectionRef.current) {
                console.log('Information section bulundu, scroll yapılıyor...');
                informationSectionRef.current.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            } else {
                console.log('Information section bulunamadı!');
            }
        }, 100);
    };

    // Kart flip fonksiyonu
    const handleCardFlip = (cardId) => {
        if (flippedCard === cardId) {
            // Aynı karta tıklanırsa kapat
            setFlippedCard(null);
        } else {
            // Farklı karta tıklanırsa o kartı aç
            setFlippedCard(cardId);
        }
    };

    // Ampul toggle fonksiyonu
    const toggleLightBulb = (bulbId) => {
        setLightBulbs(prevBulbs =>
            prevBulbs.map(bulb =>
                bulb.id === bulbId ? { ...bulb, isOn: !bulb.isOn } : bulb
            )
        );
    };



    useEffect(() => {
        // Sayfa yüklendiğinde en üste scroll et
        window.scrollTo(0, 0);

        const timer = setInterval(() => {
            const now = new Date().getTime();
            const distance = eventDate.getTime() - now;

            if (distance > 0) {
                setTimeLeft({
                    days: Math.floor(distance / (1000 * 60 * 60 * 24)),
                    hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
                    minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
                    seconds: Math.floor((distance % (1000 * 60)) / 1000)
                });
            } else {
                setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
            }
        }, 1000);

        // Sayfa yüklendiğinde konfeti başlat
        const confettiTimer = setTimeout(() => {
            startPageLoadConfetti();
        }, 1000);

        // Pencere boyutu değiştiğinde canvas'ı yeniden boyutlandır
        const handleResize = () => {
            const canvas = confettiCanvasRef.current;
            if (canvas) {
                canvas.width = window.innerWidth;
                canvas.height = window.innerHeight;
            }
        };

        window.addEventListener('resize', handleResize);

        return () => {
            clearInterval(timer);
            clearTimeout(confettiTimer);
            window.removeEventListener('resize', handleResize);
            if (animationFrameRef.current) {
                cancelAnimationFrame(animationFrameRef.current);
            }
        };
    }, []);

    const toggleDateExpansion = () => {
        console.log('Countdown bölümü tıklandı!');
        setIsDateExpanded(!isDateExpanded);
    };

    // 3 saniyede bir otomatik geçiş yapan useEffect
    useEffect(() => {
        const autoToggleTimer = setInterval(() => {
            setIsDateExpanded(prev => !prev);
        }, 3000);

        return () => clearInterval(autoToggleTimer);
    }, []);

    return (
        <div className="min-h-screen relative overflow-hidden bg-white">
            {/* Konfeti Canvas */}
            <canvas
                ref={confettiCanvasRef}
                className="fixed top-0 left-0 w-full h-full pointer-events-none z-50"
                style={{ zIndex: 1000 }}
            />

            {/* Geri Dön Butonu */}
            <button
                onClick={() => navigate('/calismalarimiz')}
                className="fixed top-6 left-6 z-50 bg-white/90 backdrop-blur-sm hover:bg-white text-gray-700 hover:text-gray-900 p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 border border-gray-200/50"
                aria-label="Çalışmalarımıza Geri Dön"
            >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                </svg>
            </button>

            {/* Hero Section */}
            <section className="relative min-h-screen flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8">
                {/* Tiyatro Perdesi */}
                {!curtainOpen && (
                    <div className="fixed inset-0 z-50">
                        {/* Sol Perde */}
                        <div className="theater-curtain theater-curtain-left"></div>
                        {/* Sağ Perde */}
                        <div className="theater-curtain theater-curtain-right"></div>
                    </div>
                )}

                {/* Perde Açılma Animasyonu */}
                {curtainOpen && (
                    <div className="fixed inset-0 z-50 pointer-events-none">
                        {/* Sol Perde - Açılma Animasyonu */}
                        <div className="theater-curtain theater-curtain-left curtain-opening-left"></div>
                        {/* Sağ Perde - Açılma Animasyonu */}
                        <div className="theater-curtain theater-curtain-right curtain-opening-right"></div>
                    </div>
                )}
                {/* Tavana Asılmış Ampuller */}
                <div className="absolute top-0 left-0 w-full z-30 pointer-events-none">
                    <div className="flex justify-center items-start pt-2 space-x-6 md:space-x-8 lg:space-x-10 xl:space-x-12">
                        {lightBulbs.map((bulb) => (
                            <div key={bulb.id} className="flex flex-col items-center pointer-events-auto">
                                {/* Kablo */}
                                <div className="w-0.5 h-6 md:h-8 lg:h-10 bg-gray-800 mb-1"></div>
                                {/* Ampul */}
                                <div
                                    className={`light-bulb cursor-pointer transition-all duration-300 transform hover:scale-110 ${bulb.isOn ? 'light-on' : 'light-off'
                                        }`}
                                    onClick={() => toggleLightBulb(bulb.id)}
                                >
                                    <div className="w-8 h-10 md:w-10 md:h-12 rounded-full relative overflow-hidden">
                                        {/* Ampul gövdesi */}
                                        <div className={`absolute inset-0 rounded-full transition-all duration-300 ${bulb.isOn
                                            ? 'bg-gradient-to-b from-yellow-200 via-yellow-300 to-yellow-400 shadow-lg shadow-yellow-300/50'
                                            : 'bg-gradient-to-b from-gray-200 via-gray-300 to-gray-400'
                                            }`}></div>
                                        {/* Ampul ışığı */}
                                        {bulb.isOn && (
                                            <div className="absolute inset-0 rounded-full bg-yellow-300 opacity-60 animate-pulse"></div>
                                        )}
                                        {/* Ampul filamenti */}
                                        <div className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-3 h-3 md:w-4 md:h-4 transition-all duration-300 ${bulb.isOn ? 'bg-orange-400' : 'bg-gray-500'
                                            } rounded-full opacity-70`}></div>
                                        {/* Ampul dişi */}
                                        <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-6 h-2 md:w-7 md:h-2 bg-gray-600 rounded-b-sm"></div>
                                    </div>
                                    {/* Işık halkası */}
                                    {bulb.isOn && (
                                        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-16 h-16 md:w-20 md:h-20 rounded-full bg-yellow-200 opacity-20 animate-ping pointer-events-none"></div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                {/* Firma Adı ve Etkinlik Başlığı */}
                <div className="header-container absolute top-16 sm:top-20 md:top-24 lg:top-28 xl:top-32 z-20 animate-fade-in-down text-center">
                    <h1 className="text-black text-base sm:text-lg md:text-xl lg:text-xl xl:text-2xl font-normal mb-2 sm:mb-3 md:mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
                        Firma Adınız
                    </h1>
                    <div className="relative">
                        <h2
                            className="event-title text-black text-5xl sm:text-6xl md:text-7xl lg:text-6xl xl:text-7xl font-bold tracking-wider leading-none"
                            style={{ fontFamily: 'Anton, sans-serif' }}
                            ref={(el) => {
                                if (el && !el.hasAttribute('data-initialized')) {
                                    el.setAttribute('data-initialized', 'true');

                                    const startTypewriterCycle = () => {
                                        const letters = ['E', 'T', 'K', 'İ', 'N', 'L', 'İ', 'K'];

                                        el.innerHTML = '';

                                        // Daktilo efekti ile harfleri ekle
                                        letters.forEach((letter, index) => {
                                            setTimeout(() => {
                                                const span = document.createElement('span');
                                                span.textContent = letter;
                                                span.className = 'typewriter-letter gradient-text';
                                                span.style.animationDelay = '0s';
                                                el.appendChild(span);

                                                // Son harf eklendiyse konfeti başlat
                                                if (index === letters.length - 1) {
                                                    setTimeout(() => {
                                                        // Harfleri soldan sağa doğru tek tek konfeti yap
                                                        const spans = el.querySelectorAll('.typewriter-letter');
                                                        const colors = ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#feca57', '#ff9ff3', '#54a0ff', '#5f27cd'];

                                                        spans.forEach((span, i) => {
                                                            setTimeout(() => {
                                                                const rect = span.getBoundingClientRect();
                                                                const centerX = rect.left + rect.width / 2;
                                                                const centerY = rect.top + rect.height / 2;

                                                                // Harfi kaybolma animasyonu ile gizle
                                                                span.style.transition = 'all 0.3s ease-out';
                                                                span.style.opacity = '0';
                                                                span.style.transform = 'scale(0) rotate(180deg)';

                                                                // Konfeti oluştur (daha az yoğun)
                                                                for (let j = 0; j < 8; j++) {
                                                                    const confetti = document.createElement('div');
                                                                    confetti.className = 'letter-confetti';
                                                                    confetti.style.left = centerX + 'px';
                                                                    confetti.style.top = centerY + 'px';
                                                                    confetti.style.backgroundColor = colors[i];

                                                                    const angle = (j * 45) + Math.random() * 20;
                                                                    const velocity = Math.random() * 150 + 100;
                                                                    confetti.style.setProperty('--angle', angle + 'deg');
                                                                    confetti.style.setProperty('--velocity', velocity + 'px');

                                                                    document.body.appendChild(confetti);

                                                                    setTimeout(() => {
                                                                        confetti.remove();
                                                                    }, 2500);
                                                                }
                                                            }, i * 150); // Her harf 150ms arayla kaybolur
                                                        });

                                                        // Döngüyü yeniden başlat (tüm harfler kaybolduktan sonra)
                                                        setTimeout(() => {
                                                            startTypewriterCycle();
                                                        }, spans.length * 150 + 2000);
                                                    }, 2000);
                                                }
                                            }, index * 200);
                                        });
                                    };

                                    startTypewriterCycle();
                                }
                            }}
                        >
                        </h2>
                        <h3 className="daveti-title absolute -bottom-2 sm:-bottom-4 md:-bottom-6 lg:-bottom-6 xl:-bottom-8 right-4 text-3xl sm:text-4xl md:text-5xl lg:text-4xl xl:text-5xl font-normal transform rotate-12" style={{ fontFamily: 'Yellowtail, cursive', color: '#e58d7b' }}>
                            Daveti
                        </h3>
                    </div>
                </div>

                {/* Wave Line Pattern Effect */}
                <div className="absolute inset-0 pointer-events-none overflow-hidden">
                    {/* Horizontal Wave Lines */}
                    <div className="wave-line wave-line-1"></div>
                    <div className="wave-line wave-line-2"></div>
                    <div className="wave-line wave-line-3"></div>
                    <div className="wave-line wave-line-4"></div>
                    <div className="wave-line wave-line-5"></div>
                </div>

                {/* Center Image */}
                <div className="relative z-10 flex items-center justify-center animate-fade-in-up mt-8">
                    <img
                        src={eventImage}
                        alt="Event"
                        className="center-image w-[20rem] h-[20rem] xs:w-[22rem] xs:h-[22rem] sm:w-[24rem] sm:h-[24rem] md:w-[26rem] md:h-[26rem] lg:w-[24rem] lg:h-[24rem] xl:w-[26rem] xl:h-[26rem] 2xl:w-[28rem] 2xl:h-[28rem] object-cover hover:scale-105 transition-transform duration-300 cursor-pointer rounded-2xl shadow-2xl"
                    />
                </div>

                {/* Hero Content */}

            </section>

            {/* Date Time Section */}
            <section className="date-time-section relative bg-white">
                <div className="date-time-container relative z-20 animate-fade-in-delay">
                    <div
                        className={`date-time-wrapper ${isDateExpanded ? 'expanded' : ''}`}
                        onClick={toggleDateExpansion}
                    >
                        {/* Date Display */}
                        <div className="date-display">
                            <span className="time-text">SAAT 08.00</span>
                            <span className="date-text">30 AĞUSTOS 2025</span>
                        </div>

                        {/* Countdown Timer (Hidden by default, shows when expanded) */}
                        <div className={`countdown-container ${isDateExpanded ? 'show' : ''}`}>
                            <div className="countdown-grid">
                                <div className="countdown-item">
                                    <span className="countdown-number">{timeLeft.days}</span>
                                    <span className="countdown-label">GÜN</span>
                                </div>
                                <div className="countdown-item">
                                    <span className="countdown-number">{timeLeft.hours}</span>
                                    <span className="countdown-label">SAAT</span>
                                </div>
                                <div className="countdown-item">
                                    <span className="countdown-number">{timeLeft.minutes}</span>
                                    <span className="countdown-label">DAKİKA</span>
                                </div>
                                <div className="countdown-item">
                                    <span className="countdown-number">{timeLeft.seconds}</span>
                                    <span className="countdown-label">SANİYE</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Action Buttons Section */}
            <section className="action-buttons-section relative py-4 bg-white">
                <div className="flex justify-center items-center gap-6 px-4">
                    {/* Detaylar Button */}
                    <button
                        className="details-btn group relative bg-gradient-to-br from-blue-500 via-blue-600 to-blue-700 text-white w-16 h-16 rounded-full shadow-2xl hover:shadow-blue-500/50 hover:scale-110 transition-all duration-500 flex items-center justify-center active:scale-95 border-2 border-blue-400/30 hover:border-blue-300/60 backdrop-blur-sm animate-fade-in-left cursor-pointer"
                        onClick={handleDetailsClick}
                    >
                        <svg className="w-6 h-6 group-hover:scale-110 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <div className="absolute inset-0 rounded-full bg-gradient-to-br from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    </button>

                    {/* Takvime Ekle Button */}
                    <button
                        className="calendar-btn group relative bg-gradient-to-br from-purple-500 via-purple-600 to-purple-700 text-white w-16 h-16 rounded-full shadow-2xl hover:shadow-purple-500/50 hover:scale-110 transition-all duration-500 flex items-center justify-center active:scale-95 border-2 border-purple-400/30 hover:border-purple-300/60 backdrop-blur-sm animate-fade-in-right cursor-pointer"
                        onClick={(e) => {
                            console.log('Takvime ekle butonu tıklandı!');
                            handleButtonConfetti(e);
                            const eventTitle = "ETKİNLİK";
                            const eventDate = "2025-08-30T08:00:00";
                            const eventEndDate = "2025-08-30T18:00:00";
                            const eventDescription = "Etkinlik Daveti";

                            // iOS Safari için
                            if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
                                const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Event//Event//EN
BEGIN:VEVENT
UID:${Date.now()}@event.com
DTSTAMP:${new Date().toISOString().replace(/[-:]/g, '').split('.')[0]}Z
DTSTART:${eventDate.replace(/[-:]/g, '').split('.')[0]}Z
DTEND:${eventEndDate.replace(/[-:]/g, '').split('.')[0]}Z
SUMMARY:${eventTitle}
DESCRIPTION:${eventDescription}
END:VEVENT
END:VCALENDAR`;

                                const blob = new Blob([icsContent], { type: 'text/calendar' });
                                const url = URL.createObjectURL(blob);
                                const link = document.createElement('a');
                                link.href = url;
                                link.download = 'etkinlik.ics';
                                link.click();
                                URL.revokeObjectURL(url);
                            }
                            // Android için Google Calendar
                            else if (/Android/.test(navigator.userAgent)) {
                                const googleCalendarUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${encodeURIComponent(eventTitle)}&dates=${eventDate.replace(/[-:]/g, '').split('.')[0]}Z/${eventEndDate.replace(/[-:]/g, '').split('.')[0]}Z&details=${encodeURIComponent(eventDescription)}`;
                                window.open(googleCalendarUrl, '_blank');
                            }
                            // Diğer cihazlar için ICS dosyası
                            else {
                                const icsContent = `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//Event//Event//EN
BEGIN:VEVENT
UID:${Date.now()}@event.com
DTSTAMP:${new Date().toISOString().replace(/[-:]/g, '').split('.')[0]}Z
DTSTART:${eventDate.replace(/[-:]/g, '').split('.')[0]}Z
DTEND:${eventEndDate.replace(/[-:]/g, '').split('.')[0]}Z
SUMMARY:${eventTitle}
DESCRIPTION:${eventDescription}
END:VEVENT
END:VCALENDAR`;

                                const blob = new Blob([icsContent], { type: 'text/calendar' });
                                const url = URL.createObjectURL(blob);
                                const link = document.createElement('a');
                                link.href = url;
                                link.download = 'etkinlik.ics';
                                link.click();
                                URL.revokeObjectURL(url);
                            }
                        }}
                    >
                        <svg className="w-6 h-6 group-hover:scale-110 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        <div className="absolute inset-0 rounded-full bg-gradient-to-br from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    </button>

                    {/* Domain Kopyala Button veya Metin */}
                    {copyButtonText ? (
                        <div className="flex items-center justify-center animate-button-appear">
                            <span className="text-green-600 font-semibold text-lg px-4 py-2 bg-green-50 rounded-lg border border-green-200 shadow-sm">
                                {copyButtonText}
                            </span>
                        </div>
                    ) : (
                        <button
                            className={`copy-domain-btn group relative bg-gradient-to-br from-green-500 via-green-600 to-green-700 text-white w-16 h-16 rounded-full shadow-2xl hover:shadow-green-500/50 hover:scale-110 transition-all duration-500 flex items-center justify-center active:scale-95 border-2 border-green-400/30 hover:border-green-300/60 backdrop-blur-sm animate-fade-in-right cursor-pointer ${isButtonAnimating ? 'animate-button-disappear' : ''}`}
                            onClick={(e) => {
                                console.log('Link kopyala butonu tıklandı!');
                                if (isButtonAnimating) return; // Animasyon sırasında tıklamayı engelle

                                handleButtonConfetti(e);
                                const currentDomain = window.location.origin;

                                // Animasyonu başlat
                                setIsButtonAnimating(true);

                                navigator.clipboard.writeText(currentDomain).then(() => {
                                    // Buton kaybolma animasyonu tamamlandıktan sonra metni göster
                                    setTimeout(() => {
                                        setCopyButtonText('Link kopyalandı');
                                    }, 300);

                                    // Geri gelme animasyonu
                                    setTimeout(() => {
                                        setCopyButtonText('');
                                        setTimeout(() => {
                                            setIsButtonAnimating(false);
                                        }, 300); // Geri gelme animasyonu için bekle
                                    }, 2000);
                                }).catch(err => {
                                    console.error('Domain kopyalanamadı: ', err);
                                    setIsButtonAnimating(false);
                                });
                            }}
                        >
                            <svg className="w-6 h-6 group-hover:scale-110 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                            </svg>
                            <div className="absolute inset-0 rounded-full bg-gradient-to-br from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                        </button>
                    )}


                </div>
            </section>

            {/* Information Section */}
            <section ref={informationSectionRef} className="information-section relative py-16 bg-gradient-to-br from-orange-50 via-white to-blue-50 overflow-hidden">
                {/* Dekoratif arka plan elementleri */}
                <div className="absolute top-0 left-0 w-full h-full">
                    <div className="absolute top-10 left-10 w-32 h-32 bg-gradient-to-br from-orange-200/30 to-orange-300/30 rounded-full blur-xl animate-pulse"></div>
                    <div className="absolute top-20 right-20 w-24 h-24 bg-gradient-to-br from-blue-200/30 to-blue-300/30 rounded-full blur-lg animate-pulse" style={{ animationDelay: '1s' }}></div>
                    <div className="absolute bottom-20 left-1/4 w-20 h-20 bg-gradient-to-br from-green-200/30 to-green-300/30 rounded-full blur-lg animate-pulse" style={{ animationDelay: '2s' }}></div>
                    <div className="absolute bottom-10 right-1/3 w-16 h-16 bg-gradient-to-br from-purple-200/30 to-purple-300/30 rounded-full blur-md animate-pulse" style={{ animationDelay: '3s' }}></div>

                    {/* Geometrik şekiller */}
                    <div className="absolute top-1/3 left-5 w-4 h-4 bg-orange-300/40 rotate-45 animate-bounce" style={{ animationDelay: '0.5s' }}></div>
                    <div className="absolute top-2/3 right-10 w-3 h-3 bg-blue-300/40 rounded-full animate-bounce" style={{ animationDelay: '1.5s' }}></div>
                    <div className="absolute bottom-1/3 left-1/2 w-2 h-8 bg-green-300/40 rounded-full animate-pulse" style={{ animationDelay: '2.5s' }}></div>
                </div>
                <div className="max-w-4xl mx-auto px-4 relative z-10">
                    {/* Title */}
                    <div className="text-center mb-16">
                        <div className="inline-block mb-6">
                            <h3 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-orange-600 via-orange-500 to-blue-600 bg-clip-text text-transparent mb-4 animate-fade-in-down" style={{ fontFamily: 'Poppins, sans-serif', lineHeight: '1.2' }}>
                                ETKİNLİK BİLGİLERİ
                            </h3>
                            <div className="flex items-center justify-center gap-2">
                                <div className="w-8 h-0.5 bg-gradient-to-r from-transparent to-orange-400 animate-fade-in-left"></div>
                                <div className="w-12 h-1 bg-gradient-to-r from-orange-400 to-blue-400 rounded-full animate-pulse"></div>
                                <div className="w-8 h-0.5 bg-gradient-to-r from-blue-400 to-transparent animate-fade-in-right"></div>
                            </div>
                        </div>
                        <p className="text-gray-600 text-lg max-w-2xl mx-auto animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
                            Etkinliğimizle ilgili tüm önemli bilgileri aşağıda bulabilirsiniz
                        </p>
                    </div>

                    {/* Card Deck Layout - İskambil destesi gibi yan yana kartlar */}
                    <div className="relative">
                        <div className="flex justify-center items-center gap-4 perspective-1000">
                            {/* Tarih & Saat Kartı */}
                            <div
                                className={`card-deck-item ${flippedCard === 'date' ? 'flipped' : ''
                                    } ${cardAnimations.date || ''}`}
                                onClick={() => handleCardFlip('date')}
                                style={{ animationDelay: '0.1s', zIndex: flippedCard === 'date' ? 50 : 4 }}
                            >
                                <div className="card-inner">
                                    {/* Kart Ön Yüzü */}
                                    <div className="card-front">
                                        <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-br from-orange-100 to-orange-200 rounded-xl mb-3 shadow-lg">
                                            <svg className="w-6 h-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                            </svg>
                                        </div>
                                        <h4 className="text-lg font-semibold text-gray-800 text-center" style={{ fontFamily: 'Poppins, sans-serif' }}>Tarih & Saat</h4>
                                    </div>
                                    {/* Kart Arka Yüzü */}
                                    <div className="card-back">
                                        <div className="text-center space-y-4 h-full flex flex-col justify-center">
                                            <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-orange-400 to-orange-600 rounded-2xl mb-2 shadow-xl mx-auto transform hover:scale-110 transition-transform duration-300">
                                                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                                </svg>
                                            </div>
                                            <h4 className="text-xl font-bold text-gray-800 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>Tarih & Saat</h4>
                                            <div className="bg-gradient-to-r from-orange-50 to-orange-100 rounded-xl p-4 space-y-3">
                                                <div className="flex items-center justify-center space-x-2">
                                                    <div className="w-2 h-2 bg-orange-500 rounded-full animate-pulse"></div>
                                                    <p className="text-gray-800 text-base font-bold">30 Ağustos 2025</p>
                                                    <div className="w-2 h-2 bg-orange-500 rounded-full animate-pulse"></div>
                                                </div>
                                                <p className="text-orange-700 text-sm font-semibold bg-white rounded-lg py-1 px-3 inline-block">Cumartesi</p>
                                                <div className="flex justify-between items-center mt-3 pt-2 border-t border-orange-200">
                                                    <div className="text-center">
                                                        <p className="text-xs text-orange-600 font-medium">Başlangıç</p>
                                                        <p className="text-sm font-bold text-gray-800">08:00</p>
                                                    </div>
                                                    <div className="w-px h-8 bg-orange-300"></div>
                                                    <div className="text-center">
                                                        <p className="text-xs text-orange-600 font-medium">Kapanış</p>
                                                        <p className="text-sm font-bold text-gray-800">18:00</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Mekan Kartı */}
                            <div
                                className={`card-deck-item ${flippedCard === 'venue' ? 'flipped' : ''
                                    } ${cardAnimations.venue || ''}`}
                                onClick={() => handleCardFlip('venue')}
                                style={{ animationDelay: '0.2s', zIndex: flippedCard === 'venue' ? 50 : 3 }}
                            >
                                <div className="card-inner">
                                    {/* Kart Ön Yüzü */}
                                    <div className="card-front">
                                        <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-br from-blue-100 to-blue-200 rounded-xl mb-3 shadow-lg">
                                            <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                            </svg>
                                        </div>
                                        <h4 className="text-lg font-semibold text-gray-800 text-center" style={{ fontFamily: 'Poppins, sans-serif' }}>Mekan</h4>
                                    </div>
                                    {/* Kart Arka Yüzü */}
                                    <div className="card-back">
                                        <div className="text-center space-y-4 h-full flex flex-col justify-center">
                                            <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-blue-400 to-blue-600 rounded-2xl mb-2 shadow-xl mx-auto transform hover:scale-110 transition-transform duration-300">
                                                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                                </svg>
                                            </div>
                                            <h4 className="text-xl font-bold text-gray-800 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>Mekan</h4>
                                            <div className="bg-gradient-to-r from-blue-50 to-blue-100 rounded-xl p-4 space-y-3">
                                                <div className="flex items-center justify-center space-x-2">
                                                    <svg className="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                                                    </svg>
                                                    <p className="text-gray-800 text-base font-bold">Etkinlik Merkezi</p>
                                                </div>
                                                <div className="flex items-center justify-center space-x-2">
                                                    <svg className="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" clipRule="evenodd" />
                                                    </svg>
                                                    <p className="text-blue-700 text-sm font-semibold">İstanbul, Türkiye</p>
                                                </div>
                                                <div className="bg-white rounded-lg p-3 mt-3">
                                                    <div className="flex items-center justify-center space-x-1 mb-1">
                                                        <div className="w-1 h-1 bg-blue-500 rounded-full"></div>
                                                        <div className="w-1 h-1 bg-blue-500 rounded-full"></div>
                                                        <div className="w-1 h-1 bg-blue-500 rounded-full"></div>
                                                    </div>
                                                    <p className="text-gray-700 text-xs font-medium">Modern ve konforlu</p>
                                                    <p className="text-gray-700 text-xs font-medium">etkinlik alanı</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Ek Bilgiler Kartı */}
                            <div
                                className={`card-deck-item ${flippedCard === 'info' ? 'flipped' : ''
                                    } ${cardAnimations.info || ''}`}
                                onClick={() => handleCardFlip('info')}
                                style={{ animationDelay: '0.3s', zIndex: flippedCard === 'info' ? 50 : 2 }}
                            >
                                <div className="card-inner">
                                    {/* Kart Ön Yüzü */}
                                    <div className="card-front">
                                        <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-br from-green-100 to-green-200 rounded-xl mb-3 shadow-lg">
                                            <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                            </svg>
                                        </div>
                                        <h4 className="text-lg font-semibold text-gray-800 text-center" style={{ fontFamily: 'Poppins, sans-serif' }}>Ek Bilgiler</h4>
                                    </div>
                                    {/* Kart Arka Yüzü */}
                                    <div className="card-back">
                                        <div className="text-center space-y-4 h-full flex flex-col justify-center">
                                            <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-green-400 to-green-600 rounded-2xl mb-2 shadow-xl mx-auto transform hover:scale-110 transition-transform duration-300">
                                                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                                </svg>
                                            </div>
                                            <h4 className="text-xl font-bold text-gray-800 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>Ek Bilgiler</h4>
                                            <div className="bg-gradient-to-r from-green-50 to-green-100 rounded-xl p-4 space-y-3">
                                                <div className="flex items-center justify-center space-x-2 mb-3">
                                                    <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                                                    <p className="text-green-800 text-sm font-bold">Önemli Notlar</p>
                                                    <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
                                                </div>
                                                <div className="space-y-2">
                                                    <div className="flex items-center space-x-3 bg-white rounded-lg p-2">
                                                        <div className="w-2 h-2 bg-green-500 rounded-full flex-shrink-0"></div>
                                                        <p className="text-gray-700 text-xs font-medium text-left">Önceden kayıt gerekli</p>
                                                    </div>
                                                    <div className="flex items-center space-x-3 bg-white rounded-lg p-2">
                                                        <div className="w-2 h-2 bg-green-500 rounded-full flex-shrink-0"></div>
                                                        <p className="text-gray-700 text-xs font-medium text-left">Uygun kıyafet tercih edin</p>
                                                    </div>
                                                    <div className="flex items-center space-x-3 bg-white rounded-lg p-2">
                                                        <div className="w-2 h-2 bg-green-500 rounded-full flex-shrink-0"></div>
                                                        <p className="text-gray-700 text-xs font-medium text-left">Ücretsiz otopark mevcut</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Konum Kartı */}
                            <div
                                className={`card-deck-item ${flippedCard === 'location' ? 'flipped' : ''
                                    } ${cardAnimations.location || ''}`}
                                onClick={() => handleCardFlip('location')}
                                style={{ animationDelay: '0.4s', zIndex: flippedCard === 'location' ? 50 : 1 }}
                            >
                                <div className="card-inner">
                                    {/* Kart Ön Yüzü */}
                                    <div className="card-front">
                                        <div className="flex items-center justify-center w-12 h-12 bg-gradient-to-br from-purple-100 to-purple-200 rounded-xl mb-3 shadow-lg">
                                            <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                            </svg>
                                        </div>
                                        <h4 className="text-lg font-semibold text-gray-800 text-center" style={{ fontFamily: 'Poppins, sans-serif' }}>Konum</h4>
                                    </div>
                                    {/* Kart Arka Yüzü */}
                                    <div className="card-back">
                                        <div className="text-center space-y-4 h-full flex flex-col justify-center">
                                            <div className="flex items-center justify-center w-16 h-16 bg-gradient-to-br from-purple-400 to-purple-600 rounded-2xl mb-2 shadow-xl mx-auto transform hover:scale-110 transition-transform duration-300">
                                                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                                </svg>
                                            </div>
                                            <h4 className="text-xl font-bold text-gray-800 mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>Konum</h4>
                                            <div className="bg-gradient-to-r from-purple-50 to-purple-100 rounded-xl p-4 space-y-3">
                                                <div className="flex items-center justify-center space-x-2">
                                                    <svg className="w-4 h-4 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                                                    </svg>
                                                    <p className="text-gray-800 text-base font-bold">Etkinlik Merkezi</p>
                                                </div>
                                                <div className="flex items-center justify-center space-x-2">
                                                    <svg className="w-4 h-4 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 011 1v2a1 1 0 01-1 1H4a1 1 0 01-1-1V4zM3 10a1 1 0 011-1h6a1 1 0 011 1v6a1 1 0 01-1 1H4a1 1 0 01-1-1v-6zM14 9a1 1 0 00-1 1v6a1 1 0 001 1h2a1 1 0 001-1v-6a1 1 0 00-1-1h-2z" clipRule="evenodd" />
                                                    </svg>
                                                    <p className="text-purple-700 text-sm font-semibold">İstanbul, Türkiye</p>
                                                </div>
                                                <div className="bg-white rounded-lg p-3 mt-3">
                                                    <button
                                                        className="w-full bg-gradient-to-r from-purple-500 to-purple-600 text-white px-4 py-2 rounded-lg text-xs font-semibold hover:from-purple-600 hover:to-purple-700 transition-all duration-300 transform hover:scale-105 shadow-lg"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            const address = "İstanbul, Türkiye";
                                                            const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
                                                            window.open(googleMapsUrl, '_blank');
                                                        }}
                                                    >
                                                        📍 Yol Tarifi Al
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>



            <style>
                {`
                @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
                @import url('https://fonts.googleapis.com/css2?family=Anton&display=swap');
                @import url('https://fonts.googleapis.com/css2?family=Yellowtail&display=swap');
                
                /* Sayfa Yüklenme Animasyonları */
                @keyframes fadeInDown {
                    0% {
                        opacity: 0;
                        transform: translateY(-30px);
                    }
                    100% {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                @keyframes fadeInUp {
                    0% {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    100% {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                
                .animate-fade-in-down {
                    animation: fadeInDown 1s ease-out forwards;
                    animation-fill-mode: both;
                }
                
                .animate-fade-in-up {
                    animation: fadeInUp 1.2s ease-out 0.3s both;
                }
                
                /* Header container için sabit pozisyon */
                .header-container {
                    position: absolute !important;
                    will-change: auto !important;
                }
                
                /* Mobil cihazlarda ETKİNLİK başlığını büyült */
                @media (max-width: 480px) {
                    .event-title {
                        font-size: 5rem !important;
                        line-height: 0.9 !important;
                    }
                    .daveti-title {
                        font-size: 3.5rem !important;
                        line-height: 1.1 !important;
                        bottom: -1.2rem !important;
                    }
                    .header-container {
                        top: 15% !important;
                    }
                    .center-image {
                        margin-top: 4rem !important;
                    }
                }
                
                @media (min-width: 481px) and (max-width: 768px) {
                    .event-title {
                        font-size: 6rem !important;
                        line-height: 0.9 !important;
                    }
                    .daveti-title {
                        font-size: 4.5rem !important;
                        line-height: 1.1 !important;
                        bottom: -1.8rem !important;
                    }
                    .header-container {
                        top: 12% !important;
                    }
                    .center-image {
                        margin-top: 3rem !important;
                    }
                }
                
                @media (min-width: 769px) and (max-width: 1024px) {
                    .event-title {
                        font-size: 7rem !important;
                        line-height: 0.9 !important;
                    }
                    .daveti-title {
                        font-size: 5rem !important;
                        line-height: 1.1 !important;
                        bottom: -2rem !important;
                    }
                }
                
                @media (min-width: 769px) and (max-width: 1023px) {
                    .header-container {
                        top: 15% !important;
                    }
                }
                .wave-line {
                    position: absolute;
                    width: 120%;
                    height: 3px;
                    left: -10%;
                    background: linear-gradient(90deg, transparent, rgba(229, 141, 123, 0.6), transparent);
                    border-radius: 50px;
                    animation: wave-flow 6s ease-in-out infinite;
                }

                .wave-line-1 {
                    top: 20%;
                    animation-delay: 0s;
                    background: linear-gradient(90deg, transparent, rgba(229, 141, 123, 0.8), transparent);
                    transform: translateX(-100%);
                }

                .wave-line-2 {
                    top: 35%;
                    animation-delay: 1s;
                    background: linear-gradient(90deg, transparent, rgba(245, 158, 135, 0.7), transparent);
                    transform: translateX(-100%);
                }

                .wave-line-3 {
                    top: 50%;
                    animation-delay: 2s;
                    background: linear-gradient(90deg, transparent, rgba(229, 141, 123, 0.6), transparent);
                    transform: translateX(-100%);
                }

                .wave-line-4 {
                    top: 65%;
                    animation-delay: 3s;
                    background: linear-gradient(90deg, transparent, rgba(213, 124, 111, 0.5), transparent);
                    transform: translateX(-100%);
                }

                .wave-line-5 {
                    top: 80%;
                    animation-delay: 4s;
                    background: linear-gradient(90deg, transparent, rgba(197, 107, 99, 0.4), transparent);
                    transform: translateX(-100%);
                }

                @keyframes wave-flow {
                    0% {
                        transform: translateX(-100%) scaleY(1);
                        opacity: 0;
                    }
                    10% {
                        opacity: 1;
                    }
                    50% {
                        transform: translateX(0%) scaleY(1.5);
                        opacity: 1;
                    }
                    90% {
                        opacity: 1;
                    }
                    100% {
                        transform: translateX(100%) scaleY(1);
                        opacity: 0;
                    }
                }

                @keyframes fade-in {
                    from {
                        opacity: 0;
                        transform: translateY(30px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }

                @keyframes fadeInLeft {
                    0% {
                        opacity: 0;
                        transform: translateX(-50px) scale(0.8);
                    }
                    100% {
                        opacity: 1;
                        transform: translateX(0) scale(1);
                    }
                }

                @keyframes fadeInRight {
                    0% {
                        opacity: 0;
                        transform: translateX(50px) scale(0.8);
                    }
                    100% {
                        opacity: 1;
                        transform: translateX(0) scale(1);
                    }
                }

                .animate-fade-in {
                    animation: fade-in 1s ease-out forwards;
                }

                .animate-fade-in-left {
                    animation: fadeInLeft 0.8s ease-out forwards;
                    animation-delay: 0.3s;
                    opacity: 0;
                }

                .animate-fade-in-right {
                    animation: fadeInRight 0.8s ease-out forwards;
                    animation-delay: 0.6s;
                    opacity: 0;
                }

                .animate-fade-in-delay {
                    animation: fade-in 1s ease-out 0.3s forwards;
                    opacity: 0;
                }

                .animate-fade-in-delay-2 {
                    animation: fade-in 1s ease-out 0.6s forwards;
                    opacity: 0;
                }

                .animate-fade-in-up {
                    animation: fadeInUp 0.3s ease-out forwards;
                }

                @keyframes fadeInUp {
                    from {
                        opacity: 0;
                        transform: translateY(10px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                


                @media (max-width: 768px) {
                    .wave-line {
                        height: 2px;
                        width: 130%;
                        left: -15%;
                    }
                    
                    .wave-line-1 { top: 15%; }
                    .wave-line-2 { top: 30%; }
                    .wave-line-3 { top: 50%; }
                    .wave-line-4 { top: 70%; }
                    .wave-line-5 { top: 85%; }
                }

                @media (min-width: 481px) and (max-width: 768px) {
                    .center-image {
                        width: 45rem !important;
                        height: 45rem !important;
                    }
                }

                @media (min-width: 769px) and (max-width: 1024px) {
                    .center-image {
                        width: 50rem !important;
                        height: 50rem !important;
                    }
                }

                @media (max-width: 480px) {
                    .wave-line {
                        height: 1.5px;
                        width: 140%;
                        left: -20%;
                    }
                    
                    .wave-line-1 { top: 10%; }
                    .wave-line-2 { top: 25%; }
                    .wave-line-3 { top: 50%; }
                    .wave-line-4 { top: 75%; }
                    .wave-line-5 { top: 90%; }
                    
                    .center-image {
                        width: 40rem !important;
                        height: 40rem !important;
                    }
                }

                @media (min-width: 1025px) and (max-width: 1279px) {
                    .center-image {
                        width: 38rem !important;
                        height: 38rem !important;
                        margin-top: 2rem !important;
                    }
                    .header-container {
                        top: 8% !important;
                    }
                }

                @media (min-width: 1280px) and (max-width: 1535px) {
                    .center-image {
                        width: 42rem !important;
                        height: 42rem !important;
                        margin-top: 2rem !important;
                    }
                    .header-container {
                        top: 8% !important;
                    }
                }

                @media (min-width: 1536px) {
                    .center-image {
                        width: 55rem !important;
                        height: 55rem !important;
                    }
                    .header-container {
                        top: 8% !important;
                    }
                }

                @media (min-width: 1200px) {
                    .wave-line {
                        height: 4px;
                        width: 110%;
                        left: -5%;
                    }
                }

                /* Date Time Section Styles */
                .date-time-section {
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    min-height: 0px;
                    margin-top: -8rem;
                    padding: 0;
                }

                /* Mobile Devices (iPhone, Samsung etc.) */
                @media (max-width: 480px) {
                    .date-time-section {
                        margin-top: -14rem;
                        padding: 0;
                        min-height: 0px;
                    }
                }

                /* Small Tablets and Large Mobile */
                @media (min-width: 481px) and (max-width: 768px) {
                    .date-time-section {
                        margin-top: -13rem;
                        padding: 0;
                        min-height: 0px;
                    }
                }

                /* Medium Tablets */
                @media (min-width: 769px) and (max-width: 1024px) {
                    .date-time-section {
                        margin-top: -8.5rem;
                        padding: 0;
                        min-height: 0px;
                    }
                }

                /* Action Buttons Section Styles */
                .action-buttons-section {
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-top: 1rem;
                    position: relative;
                    z-index: 30;
                }

                .details-btn, .calendar-btn, .copy-domain-btn {
                    width: 56px;
                    height: 56px;
                    position: relative;
                    overflow: hidden;
                    border: none;
                    cursor: pointer;
                    pointer-events: auto;
                    touch-action: manipulation;
                    z-index: 31;
                }

                .details-btn::before, .calendar-btn::before, .copy-domain-btn::before {
                    content: '';
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    width: 0;
                    height: 0;
                    background: radial-gradient(circle, rgba(255,255,255,0.3) 0%, transparent 70%);
                    border-radius: 50%;
                    transform: translate(-50%, -50%);
                    transition: all 0.6s ease;
                }

                .details-btn:hover::before, .calendar-btn:hover::before, .copy-domain-btn:hover::before {
                    width: 100px;
                    height: 100px;
                }

                .details-btn:active, .calendar-btn:active, .copy-domain-btn:active {
                    transform: scale(0.98);
                }

                /* Mobile Responsive for Buttons */
                @media (max-width: 480px) {
                    .action-buttons-section {
                        margin-top: 1rem;
                        padding: 0.5rem 0;
                        z-index: 30;
                    }
                    
                    .details-btn, .calendar-btn, .copy-domain-btn {
                        width: 52px;
                        height: 52px;
                        min-width: 44px;
                        min-height: 44px;
                        position: relative;
                        z-index: 31;
                        pointer-events: auto;
                        touch-action: manipulation;
                    }
                    
                    .details-btn svg, .calendar-btn svg, .copy-domain-btn svg {
                        width: 20px;
                        height: 20px;
                    }
                    
                    .action-buttons-section .flex {
                        gap: 1rem;
                    }
                }

                /* Small Tablets */
                @media (min-width: 481px) and (max-width: 768px) {
                    .action-buttons-section {
                        margin-top: 1.5rem;
                    }
                    
                    .details-btn, .calendar-btn, .copy-domain-btn {
                        width: 52px;
                        height: 52px;
                    }
                    
                    .details-btn svg, .calendar-btn svg, .copy-domain-btn svg {
                        width: 22px;
                        height: 22px;
                    }
                }

                .date-time-container {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: 100%;
                }

                .date-time-wrapper {
                    position: relative;
                    background: white;
                    border: 2px solid #e5e7eb;
                    border-radius: 50px;
                    padding: 0;
                    cursor: pointer;
                    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
                    overflow: hidden;
                    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
                    min-width: 280px;
                    height: 60px;
                }

                .date-time-wrapper:hover {
                    box-shadow: 0 8px 25px rgba(229, 141, 123, 0.2);
                    border-color: #e58d7b;
                }

                .date-display {
                    display: flex;
                    align-items: center;
                    height: 100%;
                    padding: 0 24px;
                    transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
                }

                .date-time-wrapper.expanded .date-display {
                    transform: translateX(-100%);
                }

                .time-text {
                    background: #e58d7b;
                    color: white;
                    padding: 8px 16px;
                    border-radius: 25px;
                    font-weight: 600;
                    font-size: 14px;
                    margin-right: 16px;
                    font-family: 'Poppins', sans-serif;
                }

                .date-text {
                    color: #374151;
                    font-weight: 600;
                    font-size: 16px;
                    font-family: 'Poppins', sans-serif;
                }

                .countdown-container {
                    position: absolute;
                    top: 0;
                    left: 100%;
                    width: 100%;
                    height: 100%;
                    background: linear-gradient(135deg, #e58d7b, #f59e87);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
                    border-radius: 50px;
                }

                .countdown-container.show {
                    transform: translateX(-100%);
                }

                .countdown-grid {
                    display: flex;
                    gap: 20px;
                    align-items: center;
                }

                .countdown-item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    color: white;
                }

                .countdown-number {
                    font-size: 18px;
                    font-weight: 700;
                    font-family: 'Poppins', sans-serif;
                    line-height: 1;
                }

                .countdown-label {
                    font-size: 10px;
                    font-weight: 500;
                    font-family: 'Poppins', sans-serif;
                    margin-top: 2px;
                    opacity: 0.9;
                }

                /* Responsive Design for Date Time Component */
                @media (max-width: 480px) {
                    .date-time-wrapper {
                        min-width: 260px;
                        height: 55px;
                    }
                    
                    .time-text {
                        font-size: 12px;
                        padding: 6px 12px;
                        margin-right: 12px;
                    }
                    
                    .date-text {
                        font-size: 14px;
                    }
                    
                    .countdown-grid {
                        gap: 15px;
                    }
                    
                    .countdown-number {
                        font-size: 16px;
                    }
                    
                    .countdown-label {
                        font-size: 9px;
                    }
                }

                @media (min-width: 481px) and (max-width: 768px) {
                    .date-time-wrapper {
                        min-width: 300px;
                        height: 65px;
                    }
                    
                    .countdown-grid {
                        gap: 18px;
                    }
                }

                @media (min-width: 769px) {
                    .date-time-wrapper {
                        min-width: 320px;
                        height: 70px;
                    }
                    
                    .time-text {
                        font-size: 15px;
                        padding: 10px 18px;
                    }
                    
                    .date-text {
                        font-size: 17px;
                    }
                    
                    .countdown-number {
                        font-size: 20px;
                    }
                    
                    .countdown-label {
                        font-size: 11px;
                    }
                }

                /* Daktilo Efekti Animasyonları */
                .typewriter-letter {
                    display: inline-block;
                    opacity: 1;
                    transform: scale(1);
                    animation: typewriterBounce 0.3s ease-out;
                }
                
                @keyframes typewriterBounce {
                    0% {
                        transform: scale(0) translateY(-20px);
                    }
                    50% {
                        transform: scale(1.2) translateY(-10px);
                    }
                    100% {
                        transform: scale(1) translateY(0);
                    }
                }

                .gradient-text {
                    animation: colorCycle 3s ease-in-out infinite;
                    font-weight: bold;
                }

                @keyframes colorCycle {
                    0% { color: #ff6b6b; }
                    12.5% { color: #4ecdc4; }
                    25% { color: #45b7d1; }
                    37.5% { color: #96ceb4; }
                    50% { color: #feca57; }
                    62.5% { color: #ff9ff3; }
                    75% { color: #54a0ff; }
                    87.5% { color: #5f27cd; }
                    100% { color: #ff6b6b; }
                }

                @keyframes gradientFlow {
                    0% {
                        background-position: 0% 50%;
                    }
                    50% {
                        background-position: 100% 50%;
                    }
                    100% {
                        background-position: 0% 50%;
                    }
                }

                @keyframes typewriterAppear {
                    0% {
                        transform: scale(0) translateY(-20px);
                        opacity: 0;
                    }
                    50% {
                        transform: scale(1.2) translateY(-10px);
                        opacity: 0.7;
                    }
                    100% {
                        transform: scale(1) translateY(0);
                        opacity: 1;
                    }
                }

                /* Harf Konfeti Animasyonu */
                .letter-confetti {
                    position: fixed;
                    width: 6px;
                    height: 6px;
                    pointer-events: none;
                    z-index: 9999;
                    border-radius: 50%;
                    animation: letterConfettiExplode 2.2s ease-out forwards;
                    box-shadow: 0 0 4px rgba(255, 255, 255, 0.6);
                }

                @keyframes letterConfettiExplode {
                    0% {
                        transform: translate(0, 0) rotate(0deg) scale(1.2);
                        opacity: 1;
                    }
                    15% {
                        transform: translate(
                            calc(cos(var(--angle)) * var(--velocity) * 0.3),
                            calc(sin(var(--angle)) * var(--velocity) * 0.3)
                        ) rotate(180deg) scale(1.3);
                        opacity: 0.9;
                    }
                    50% {
                        transform: translate(
                            calc(cos(var(--angle)) * var(--velocity) * 0.7),
                            calc(sin(var(--angle)) * var(--velocity) * 0.7)
                        ) rotate(360deg) scale(1.0);
                        opacity: 0.6;
                    }
                    100% {
                        transform: translate(
                            calc(cos(var(--angle)) * var(--velocity)),
                            calc(sin(var(--angle)) * var(--velocity) + 200px)
                        ) rotate(540deg) scale(0);
                        opacity: 0;
                    }
                }

                /* Başlık genel stilleri */
                .event-title {
                    min-height: 1.2em;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                /* Card Deck Styles */
                .perspective-1000 {
                    perspective: 1000px;
                }

                .card-deck-item {
                    width: 200px;
                    height: 280px;
                    position: relative;
                    cursor: pointer;
                    transition: all 0.6s ease;
                    transform-style: preserve-3d;
                    margin: 0 -20px;
                }

                .card-deck-item:hover {
                    transform: translateY(-10px) scale(1.05);
                }

                .card-deck-item.flipped {
                    transform: rotateY(180deg) translateY(-20px) scale(1.1);
                }

                .card-inner {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    text-align: center;
                    transition: transform 0.6s;
                    transform-style: preserve-3d;
                }

                .card-front, .card-back {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    backface-visibility: hidden;
                    border-radius: 20px;
                    padding: 20px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    background: linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.8) 100%);
                    backdrop-filter: blur(10px);
                    border: 1px solid rgba(255,255,255,0.5);
                    box-shadow: 0 8px 32px rgba(0,0,0,0.1);
                }

                .card-back {
                    transform: rotateY(180deg);
                    background: linear-gradient(135deg, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.9) 100%);
                }

                .card-deck-item:nth-child(1) {
                    transform: rotate(-8deg);
                }

                .card-deck-item:nth-child(2) {
                    transform: rotate(-4deg);
                }

                .card-deck-item:nth-child(3) {
                    transform: rotate(4deg);
                }

                .card-deck-item:nth-child(4) {
                    transform: rotate(8deg);
                }

                .card-deck-item:nth-child(1):hover {
                    transform: rotate(-8deg) translateY(-10px) scale(1.05);
                }

                .card-deck-item:nth-child(2):hover {
                    transform: rotate(-4deg) translateY(-10px) scale(1.05);
                }

                .card-deck-item:nth-child(3):hover {
                    transform: rotate(4deg) translateY(-10px) scale(1.05);
                }

                .card-deck-item:nth-child(4):hover {
                    transform: rotate(8deg) translateY(-10px) scale(1.05);
                }

                .card-deck-item:nth-child(1).flipped {
                    transform: rotate(-8deg) rotateY(180deg) translateY(-20px) scale(1.1);
                }

                .card-deck-item:nth-child(2).flipped {
                    transform: rotate(-4deg) rotateY(180deg) translateY(-20px) scale(1.1);
                }

                .card-deck-item:nth-child(3).flipped {
                    transform: rotate(4deg) rotateY(180deg) translateY(-20px) scale(1.1);
                }

                .card-deck-item:nth-child(4).flipped {
                    transform: rotate(8deg) rotateY(180deg) translateY(-20px) scale(1.1);
                }

                /* Ampul Stilleri */
                .light-bulb {
                    position: relative;
                    filter: drop-shadow(0 4px 8px rgba(0,0,0,0.1));
                }

                .light-bulb:hover {
                    filter: drop-shadow(0 6px 12px rgba(0,0,0,0.15));
                }

                .light-on {
                    filter: drop-shadow(0 0 20px rgba(255,255,0,0.6)) drop-shadow(0 4px 8px rgba(0,0,0,0.1));
                }

                .light-off {
                    filter: drop-shadow(0 4px 8px rgba(0,0,0,0.1));
                }

                @keyframes glow {
                    0%, 100% { box-shadow: 0 0 5px rgba(255,255,0,0.1); }
                    50% { box-shadow: 0 0 8px rgba(255,255,0,0.2); }
                }
                
                @keyframes sway {
                    0%, 100% { transform: rotate(-2deg); }
                    50% { transform: rotate(2deg); }
                }

                .light-on .absolute.inset-0 {
                    animation: glow 2s ease-in-out infinite;
                }
                
                .light-bulb {
                    animation: sway 3s ease-in-out infinite;
                    transform-origin: top center;
                }

                /* Tiyatro Perdesi Stilleri */
                .theater-curtain {
                    position: absolute;
                    top: 0;
                    width: 50%;
                    height: 100%;
                    background: linear-gradient(90deg, 
                        #8B0000 0%, 
                        #B22222 30%, 
                        #DC143C 50%, 
                        #B22222 70%, 
                        #8B0000 100%);
                    box-shadow: inset 0 0 30px rgba(0,0,0,0.3);
                    z-index: 5;
                    transition: transform 2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
                }

                .theater-curtain::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: repeating-linear-gradient(
                        0deg,
                        transparent 0px,
                        rgba(0,0,0,0.15) 3px,
                        transparent 6px
                    );
                }

                .theater-curtain::after {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: linear-gradient(
                        180deg,
                        rgba(255,255,255,0.1) 0%,
                        transparent 30%,
                        transparent 70%,
                        rgba(0,0,0,0.1) 100%
                    );
                }

                .theater-curtain-left {
                    left: 0;
                    border-radius: 0 30px 30px 0;
                    box-shadow: 10px 0 25px rgba(0,0,0,0.4), inset 0 0 30px rgba(0,0,0,0.3);
                    transform-origin: left center;
                }

                .theater-curtain-right {
                    right: 0;
                    border-radius: 30px 0 0 30px;
                    box-shadow: -10px 0 25px rgba(0,0,0,0.4), inset 0 0 30px rgba(0,0,0,0.3);
                    transform-origin: right center;
                }

                /* Perde Açılma Animasyonları */
                @keyframes curtain-open-left {
                    0% {
                        transform: translateX(0) scaleX(1);
                    }
                    100% {
                        transform: translateX(-100%) scaleX(0.8);
                    }
                }

                @keyframes curtain-open-right {
                    0% {
                        transform: translateX(0) scaleX(1);
                    }
                    100% {
                        transform: translateX(100%) scaleX(0.8);
                    }
                }

                .curtain-opening-left {
                    animation: curtain-open-left 2s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
                }

                .curtain-opening-right {
                    animation: curtain-open-right 2s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
                }

                /* Kapalı perdeler için hafif sallanma */
                @keyframes curtain-sway {
                    0%, 100% { transform: translateX(0px) rotate(0deg); }
                    25% { transform: translateX(1px) rotate(0.2deg); }
                    75% { transform: translateX(-1px) rotate(-0.2deg); }
                }

                .theater-curtain:not(.curtain-opening-left):not(.curtain-opening-right) {
                    animation: curtain-sway 6s ease-in-out infinite;
                }

                /* Buton animasyonları */
                @keyframes button-disappear {
                    0% {
                        opacity: 1;
                        transform: scale(1) rotateY(0deg);
                    }
                    50% {
                        opacity: 0.5;
                        transform: scale(0.8) rotateY(90deg);
                    }
                    100% {
                        opacity: 0;
                        transform: scale(0.6) rotateY(180deg);
                    }
                }

                @keyframes button-appear {
                    0% {
                        opacity: 0;
                        transform: scale(0.6) rotateY(180deg);
                    }
                    50% {
                        opacity: 0.5;
                        transform: scale(0.8) rotateY(90deg);
                    }
                    100% {
                        opacity: 1;
                        transform: scale(1) rotateY(0deg);
                    }
                }

                .animate-button-disappear {
                    animation: button-disappear 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
                }

                .animate-button-appear {
                    animation: button-appear 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
                }

                .theater-curtain-left:not(.curtain-opening-left) {
                    animation-delay: 0s;
                }

                .theater-curtain-right:not(.curtain-opening-right) {
                    animation-delay: 3s;
                }

                /* Footer Animations */
                @keyframes float {
                    0%, 100% {
                        transform: translateY(0px) rotate(0deg);
                        opacity: 0.3;
                    }
                    50% {
                        transform: translateY(-20px) rotate(180deg);
                        opacity: 1;
                    }
                }

                .animate-float {
                    animation: float 6s ease-in-out infinite;
                }

                /* Gradient Text Animation */
                @keyframes gradient-shift {
                    0% {
                        background-position: 0% 50%;
                    }
                    50% {
                        background-position: 100% 50%;
                    }
                    100% {
                        background-position: 0% 50%;
                    }
                }

                .animate-gradient {
                    background-size: 200% 200%;
                    animation: gradient-shift 3s ease infinite;
                }

                /* Pulse Glow Effect */
                @keyframes pulse-glow {
                    0%, 100% {
                        box-shadow: 0 0 20px rgba(255, 255, 255, 0.1);
                    }
                    50% {
                        box-shadow: 0 0 40px rgba(255, 255, 255, 0.3), 0 0 60px rgba(255, 255, 255, 0.1);
                    }
                }

                .animate-pulse-glow {
                    animation: pulse-glow 2s ease-in-out infinite;
                }
                `}
            </style>

            {/* Footer */}
            <footer className="bg-gray-50 border-t border-gray-200 py-8 mt-20">
                <div className="container mx-auto px-6">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                        {/* Etkinlik Bilgileri */}
                        <div className="text-center md:text-left">
                            <h3 className="text-lg font-bold text-gray-800 mb-3">Etkinlik Bilgileri</h3>
                            <div className="space-y-2 text-gray-600 text-sm">
                                <div className="flex items-center justify-center md:justify-start space-x-2">
                                    <span className="text-orange-500">📅</span>
                                    <span>30 Ağustos 2025, Cumartesi</span>
                                </div>
                                <div className="flex items-center justify-center md:justify-start space-x-2">
                                    <span className="text-blue-500">🕐</span>
                                    <span>08:00 - 18:00</span>
                                </div>
                                <div className="flex items-center justify-center md:justify-start space-x-2">
                                    <span className="text-green-500">📍</span>
                                    <span>İstanbul, Türkiye</span>
                                </div>
                                <div className="flex items-center justify-center md:justify-start space-x-2">
                                    <span className="text-purple-500">ℹ️</span>
                                    <span>Önceden kayıt gerekli</span>
                                </div>
                            </div>
                        </div>

                        {/* Şirket Logosu ve Bilgi */}
                        <div className="text-center">
                            <div className="w-20 h-20 bg-gradient-to-br from-purple-500 to-purple-700 rounded-xl flex items-center justify-center mx-auto mb-3 shadow-lg">
                                <span className="text-2xl font-bold text-white">LOGO</span>
                            </div>
                            <h4 className="text-base font-semibold text-gray-800 mb-2">Firma Adınız</h4>
                            <p className="text-gray-600 text-xs">
                                Etkinliklerinizi unutulmaz kılıyoruz
                            </p>
                        </div>

                        {/* İletişim */}
                        <div className="text-center md:text-left">
                            <h4 className="text-lg font-bold text-gray-800 mb-3">İletişim</h4>
                            <div className="space-y-2 text-gray-600 text-sm">
                                <div className="flex items-center justify-center md:justify-start space-x-2">
                                    <span className="text-blue-500">📧</span>
                                    <span>info@firmaniz.com</span>
                                </div>
                                <div className="flex items-center justify-center md:justify-start space-x-2">
                                    <span className="text-green-500">📱</span>
                                    <span>+90 555 123 45 67</span>
                                </div>
                                <div className="flex items-center justify-center md:justify-start space-x-2">
                                    <span className="text-red-500">🌐</span>
                                    <span>www.firmaniz.com</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="border-t border-gray-300 mt-6 pt-4 text-center">
                        <p className="text-gray-500 text-xs">
                            © 2025 <strong>Dijivite</strong>. Bu etkinlik daveti <strong>Dijivite</strong> tarafından özel olarak hazırlanmıştır.
                        </p>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Event;